import React, { useState, useEffect, useRef } from 'react';
import { Send, Ticket, Users, Calendar, TrendingUp, MapPin, BarChart3, MessageSquare, Zap, ChevronRight, X, Loader2, RefreshCw, Target, DollarSign, Clock, Star, CheckCircle, AlertCircle, AlertTriangle, Database, Activity } from 'lucide-react';

const nbaHomeGames = [
  { id: 1, date: "Feb 1", fullDate: "2026-02-01", opp: "Magic", tri: "ORL", time: "4:00 PM ET", gid: "0022500703" },
  { id: 2, date: "Feb 4", fullDate: "2026-02-04", opp: "Thunder", tri: "OKC", time: "9:30 PM ET", gid: "0022500730" },
  { id: 3, date: "Feb 7", fullDate: "2026-02-07", opp: "Mavericks", tri: "DAL", time: "6:00 PM ET", gid: "0022500749" },
  { id: 4, date: "Feb 19", fullDate: "2026-02-19", opp: "Suns", tri: "PHX", time: "8:30 PM ET", gid: "0022500798" },
  { id: 5, date: "Feb 21", fullDate: "2026-02-21", opp: "Kings", tri: "SAC", time: "8:00 PM ET", gid: "0022500815" },
  { id: 6, date: "Mar 5", fullDate: "2026-03-05", opp: "Pistons", tri: "DET", time: "8:00 PM ET", gid: "0022500904" },
  { id: 7, date: "Mar 6", fullDate: "2026-03-06", opp: "Clippers", tri: "LAC", time: "9:30 PM ET", gid: "0022500913" },
  { id: 8, date: "Mar 8", fullDate: "2026-03-08", opp: "Rockets", tri: "HOU", time: "8:00 PM ET", gid: "0022500927" },
  { id: 9, date: "Mar 10", fullDate: "2026-03-10", opp: "Celtics", tri: "BOS", time: "8:00 PM ET", gid: "0022500942" },
  { id: 10, date: "Mar 12", fullDate: "2026-03-12", opp: "Nuggets", tri: "DEN", time: "9:00 PM ET", gid: "0022500958" },
  { id: 11, date: "Mar 14", fullDate: "2026-03-14", opp: "Hornets", tri: "CHA", time: "8:00 PM ET", gid: "0022500973" },
  { id: 12, date: "Mar 19", fullDate: "2026-03-19", opp: "Suns", tri: "PHX", time: "8:00 PM ET", gid: "0022501013" },
  { id: 13, date: "Mar 21", fullDate: "2026-03-21", opp: "Pacers", tri: "IND", time: "8:00 PM ET", gid: "0022501028" },
  { id: 14, date: "Mar 30", fullDate: "2026-03-30", opp: "Bulls", tri: "CHI", time: "8:00 PM ET", gid: "0022501094" },
  { id: 15, date: "Apr 6", fullDate: "2026-04-06", opp: "76ers", tri: "PHI", time: "8:00 PM ET", gid: "0022501146" },
  { id: 16, date: "Apr 8", fullDate: "2026-04-08", opp: "Trail Blazers", tri: "POR", time: "8:00 PM ET", gid: "0022501161" },
  { id: 17, date: "Apr 10", fullDate: "2026-04-10", opp: "Mavericks", tri: "DAL", time: "8:00 PM ET", gid: "0022501180" },
  { id: 18, date: "Apr 12", fullDate: "2026-04-12", opp: "Nuggets", tri: "DEN", time: "8:30 PM ET", gid: "0022501197" },
];

const nbaAwayGames = [
  { date: "Jan 28", opp: "Rockets", tri: "HOU", time: "9:30 PM ET" },
  { date: "Jan 31", opp: "Hornets", tri: "CHA", time: "3:00 PM ET" },
  { date: "Feb 5", opp: "Mavericks", tri: "DAL", time: "8:30 PM ET" },
  { date: "Feb 10", opp: "Lakers", tri: "LAL", time: "10:30 PM ET" },
  { date: "Feb 11", opp: "Warriors", tri: "GSW", time: "10:00 PM ET" },
  { date: "Feb 23", opp: "Pistons", tri: "DET", time: "7:00 PM ET" },
  { date: "Feb 25", opp: "Raptors", tri: "TOR", time: "7:30 PM ET" },
  { date: "Feb 26", opp: "Nets", tri: "BKN", time: "7:30 PM ET" },
  { date: "Mar 1", opp: "Knicks", tri: "NYK", time: "1:00 PM ET" },
  { date: "Mar 3", opp: "76ers", tri: "PHI", time: "8:00 PM ET" },
  { date: "Mar 16", opp: "Clippers", tri: "LAC", time: "10:30 PM ET" },
  { date: "Mar 17", opp: "Kings", tri: "SAC", time: "11:00 PM ET" },
  { date: "Mar 23", opp: "Heat", tri: "MIA", time: "7:30 PM ET" },
  { date: "Mar 25", opp: "Grizzlies", tri: "MEM", time: "8:00 PM ET" },
  { date: "Mar 28", opp: "Bucks", tri: "MIL", time: "3:00 PM ET" },
  { date: "Apr 1", opp: "Warriors", tri: "GSW", time: "10:00 PM ET" },
  { date: "Apr 2", opp: "Clippers", tri: "LAC", time: "10:30 PM ET" },
  { date: "Apr 4", opp: "Nuggets", tri: "DEN", time: "3:00 PM ET" },
];

const leagueLeaders = [
  { rank: 1, name: "Shai Gilgeous-Alexander", team: "OKC", ppg: 32.7, rpg: 5.0, apg: 6.4, gp: 76 },
  { rank: 2, name: "Giannis Antetokounmpo", team: "MIL", ppg: 30.4, rpg: 11.9, apg: 6.5, gp: 67 },
  { rank: 3, name: "Nikola Jokic", team: "DEN", ppg: 29.6, rpg: 12.7, apg: 10.2, gp: 70 },
  { rank: 4, name: "Anthony Edwards", team: "MIN", ppg: 27.6, rpg: 5.7, apg: 4.5, gp: 79 },
  { rank: 5, name: "Jayson Tatum", team: "BOS", ppg: 26.8, rpg: 8.7, apg: 6.0, gp: 72 },
  { rank: 6, name: "Kevin Durant", team: "PHX", ppg: 26.6, rpg: 6.0, apg: 4.2, gp: 62 },
  { rank: 7, name: "Cade Cunningham", team: "DET", ppg: 26.1, rpg: 6.1, apg: 9.1, gp: 70 },
  { rank: 8, name: "Jalen Brunson", team: "NYK", ppg: 26.0, rpg: 2.9, apg: 7.3, gp: 65 },
  { rank: 18, name: "De'Aaron Fox", team: "SAS", ppg: 23.5, rpg: 4.8, apg: 6.3, gp: 62, isSpurs: true },
];

const historicalTicketData = [
  { opp: "Guangzhou Loong Lions", date: "Oct 7, 2025", offers: 1036, priceRange: "N/A", type: "Preseason" },
  { opp: "Utah Jazz", date: "Oct 11, 2025", offers: 1071, priceRange: "$7-$862", type: "Preseason" },
  { opp: "Indiana Pacers", date: "Oct 18, 2025", offers: 1080, priceRange: "N/A", type: "Preseason" },
  { opp: "Brooklyn Nets", date: "Oct 26, 2025", offers: 1199, priceRange: "N/A", type: "Regular" },
  { opp: "Toronto Raptors", date: "Oct 28, 2025", offers: 1193, priceRange: "N/A", type: "Regular" },
  { opp: "Miami Heat", date: "Oct 31, 2025", offers: 1205, priceRange: "$6.24-$985", type: "Regular" },
  { opp: "Houston Rockets", date: "Nov 8, 2025", offers: 1138, priceRange: "$6.24-$958", type: "Regular" },
  { opp: "New Orleans Pelicans", date: "Nov 9, 2025", offers: 1126, priceRange: "N/A", type: "Regular" },
  { opp: "Golden State Warriors", date: "Nov 13, 2025", offers: 1056, priceRange: "$24-$982", type: "Regular" },
  { opp: "Golden State Warriors", date: "Nov 15, 2025", offers: 1063, priceRange: "$24-$982", type: "Regular" },
  { opp: "Sacramento Kings", date: "Nov 16, 2025", offers: 1104, priceRange: "$13-$940", type: "Regular" },
  { opp: "Memphis Grizzlies", date: "Nov 19, 2025", offers: 1026, priceRange: "$9-$898", type: "Regular" },
  { opp: "Atlanta Hawks", date: "Nov 21, 2025", offers: 1033, priceRange: "$16-$996", type: "Regular" },
];

const totalHistoricalOffers = historicalTicketData.reduce((s, e) => s + e.offers, 0);
const avgOffersPerGame = Math.round(totalHistoricalOffers / historicalTicketData.length);

const sampleQuestions = [
  "When is the next home game?",
  "How is De'Aaron Fox performing this season?",
  "What rivals do we play at home in March?",
  "Why is Ticketmaster showing 2025 data?",
  "What was the average ticket inventory in early season?",
  "Which upcoming opponents have the best scorers?",
];

export default function SpursHub() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'assistant', content: "Welcome to the Spurs MCP Intelligence Hub.\n\nData Status (Feb 5, 2026):\n\n\u2705 NBA-MCP: LIVE - 36 remaining games, league stats current\n\u26A0\uFE0F Ticketmaster: STALE - Only Oct-Nov 2025 data loaded\n\u274C BigQuery: CONNECTION FAILED\n\nI'll always be transparent about what's current vs historical. What can I help with?" }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const chatEnd = useRef(null);

  useEffect(() => { chatEnd.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const today = new Date('2026-02-05');
  const futureHomeGames = nbaHomeGames.filter(g => new Date(g.fullDate) >= today);
  const nextGame = futureHomeGames[0];
  const fox = leagueLeaders.find(l => l.isSpurs);

  const handleSend = async () => {
    if (!input.trim() || loading) return;
    const msg = input.trim();
    setMessages(p => [...p, { role: 'user', content: msg }]);
    setInput('');
    setLoading(true);
    try {
      const sys = `You are the Spurs MCP Intelligence Assistant. Today is February 5, 2026.

CRITICAL DATA FRESHNESS RULES:
- NBA-MCP data is CURRENT (2025-26 season, verified live)
- Ticketmaster data is STALE: only Oct-Nov 2025 events loaded. NO 2026 ticket data exists.
- BigQuery is UNAVAILABLE
- ALWAYS state data source and freshness
- NEVER present 2025 Ticketmaster data as current inventory

CURRENT DATA - NBA-MCP (Live):
Upcoming Home Games (${futureHomeGames.length} remaining):
${futureHomeGames.map(g => `${g.date}, 2026 vs ${g.opp} (${g.tri}) at ${g.time}`).join('\n')}

Away Games: ${nbaAwayGames.length} remaining
Total: 36 games left in 2025-26 season

League Scoring Leaders:
${leagueLeaders.map(l => `#${l.rank} ${l.name} (${l.team}): ${l.ppg} PPG, ${l.rpg} RPG, ${l.apg} APG, ${l.gp} GP${l.isSpurs ? ' << SPURS' : ''}`).join('\n')}

HISTORICAL - Ticketmaster (Oct-Nov 2025 ONLY, all games played):
${historicalTicketData.map(e => `${e.date} vs ${e.opp}: ${e.offers} offers, ${e.priceRange}`).join('\n')}
Avg offers/game: ${avgOffersPerGame}
Note: This is 3-4 months old. Use only as baseline benchmark.`;

      const res = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514', max_tokens: 1000, system: sys,
          messages: [...messages.slice(1).map(m => ({ role: m.role, content: m.content })), { role: 'user', content: msg }]
        })
      });
      const data = await res.json();
      setMessages(p => [...p, { role: 'assistant', content: data.content?.[0]?.text || "Unable to process." }]);
    } catch { setMessages(p => [...p, { role: 'assistant', content: "Connection error." }]); }
    finally { setLoading(false); }
  };

  const Badge = ({ status, label }) => {
    const c = { live: { bg: 'rgba(16,185,129,0.15)', b: 'rgba(16,185,129,0.4)', t: '#10B981', I: CheckCircle },
      stale: { bg: 'rgba(245,158,11,0.15)', b: 'rgba(245,158,11,0.4)', t: '#F59E0B', I: AlertTriangle },
      down: { bg: 'rgba(239,68,68,0.15)', b: 'rgba(239,68,68,0.4)', t: '#EF4444', I: X } }[status];
    return (<div style={{ display:'flex',alignItems:'center',gap:'5px',padding:'4px 10px',background:c.bg,border:`1px solid ${c.b}`,borderRadius:'6px' }}><c.I size={11} color={c.t} /><span style={{ fontSize:'10px',color:c.t,fontWeight:'500' }}>{label}</span></div>);
  };

  return (
    <div style={{ minHeight:'100vh',background:'linear-gradient(135deg,#041624 0%,#0D2145 50%,#0a1929 100%)',color:'#F6F5F3',fontFamily:"'Inter',-apple-system,sans-serif" }}>
      {/* Header */}
      <div style={{ padding:'14px 24px',borderBottom:'1px solid rgba(96,87,168,0.2)',display:'flex',justifyContent:'space-between',alignItems:'center',background:'rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex',alignItems:'center',gap:'14px' }}>
          <div style={{ width:'42px',height:'42px',background:'linear-gradient(135deg,#C4CED4,#fff)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'700',color:'#041624',fontSize:'11px' }}>SAS</div>
          <div>
            <h1 style={{ fontSize:'18px',fontWeight:'600',letterSpacing:'-0.04em',margin:0 }}>Spurs MCP Intelligence Hub</h1>
            <p style={{ fontSize:'10px',color:'#BDBEBE',margin:'2px 0 0' }}>Feb 5, 2026 - Centillion.ai</p>
          </div>
        </div>
        <div style={{ display:'flex',alignItems:'center',gap:'8px' }}>
          <Badge status="live" label="NBA-MCP Live" />
          <Badge status="stale" label="Ticketmaster 2025" />
          <Badge status="down" label="BigQuery" />
          <button onClick={() => setChatOpen(!chatOpen)} style={{ display:'flex',alignItems:'center',gap:'6px',background:'linear-gradient(135deg,#6057A8,#223B6E)',border:'none',borderRadius:'10px',padding:'9px 16px',color:'#fff',cursor:'pointer',fontWeight:'500',fontSize:'12px',marginLeft:'8px' }}><MessageSquare size={14} /> Ask AI</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex',gap:'4px',padding:'10px 24px',borderBottom:'1px solid rgba(96,87,168,0.1)',background:'rgba(0,0,0,0.2)' }}>
        {['dashboard','schedule','stats','historical tickets'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{ padding:'7px 18px',background:activeTab===tab?'rgba(96,87,168,0.3)':'transparent',border:activeTab===tab?'1px solid rgba(96,87,168,0.5)':'1px solid transparent',borderRadius:'8px',color:activeTab===tab?'#fff':'#BDBEBE',cursor:'pointer',fontSize:'12px',fontWeight:'500',textTransform:'capitalize' }}>{tab}</button>
        ))}
      </div>

      <div style={{ padding:'20px 24px' }}>
        {activeTab === 'dashboard' && (<>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'14px',marginBottom:'20px' }}>
            {[
              { label:'Home Games Left',value:futureHomeGames.length,sub:'Through Apr 12, 2026',icon:MapPin,color:'#10B981',s:'live' },
              { label:'Total Games Left',value:'36',sub:'18 home / 18 away',icon:Calendar,color:'#06B6D4',s:'live' },
              { label:"Fox PPG (#18 in NBA)",value:'23.5',sub:`${fox.gp} GP / 36.1 MPG`,icon:Star,color:'#6057A8',s:'live' },
              { label:'TM Avg Offers (2025)',value:avgOffersPerGame.toLocaleString(),sub:'Historical baseline only',icon:Ticket,color:'#F59E0B',s:'stale' },
            ].map((k,i) => (
              <div key={i} style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'18px' }}>
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'10px' }}>
                  <span style={{ fontSize:'10px',color:'#BDBEBE',textTransform:'uppercase',letterSpacing:'0.05em' }}>{k.label}</span>
                  <div style={{ display:'flex',alignItems:'center',gap:'4px' }}>
                    {k.s==='live'?<CheckCircle size={10} color="#10B981" />:<AlertTriangle size={10} color="#F59E0B" />}
                    <k.icon size={16} color={k.color} />
                  </div>
                </div>
                <div style={{ fontSize:'26px',fontWeight:'700',color:k.color }}>{k.value}</div>
                <div style={{ fontSize:'10px',color:'#BDBEBE',marginTop:'4px' }}>{k.sub}</div>
              </div>
            ))}
          </div>

          {nextGame && (
            <div style={{ background:'linear-gradient(135deg,rgba(96,87,168,0.25),rgba(34,59,110,0.4))',border:'1px solid rgba(96,87,168,0.4)',borderRadius:'16px',padding:'22px',marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
              <div>
                <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'6px' }}>
                  <span style={{ fontSize:'10px',color:'#10B981',textTransform:'uppercase',fontWeight:'600',letterSpacing:'0.05em' }}>Next Home Game</span>
                  <CheckCircle size={12} color="#10B981" />
                </div>
                <div style={{ fontSize:'24px',fontWeight:'700' }}>Spurs vs {nextGame.opp}</div>
                <div style={{ fontSize:'13px',color:'#BDBEBE',marginTop:'4px' }}>{nextGame.date}, 2026 - {nextGame.time} - Frost Bank Center</div>
              </div>
              <div style={{ fontSize:'48px',fontWeight:'700',color:'rgba(96,87,168,0.4)' }}>{nextGame.tri}</div>
            </div>
          )}

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px' }}>
            <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'18px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'14px' }}>
                <h3 style={{ fontSize:'13px',fontWeight:'600',color:'#C4CED4',margin:0 }}>Upcoming Home Games</h3>
                <CheckCircle size={12} color="#10B981" />
                <span style={{ fontSize:'9px',color:'#10B981',marginLeft:'auto' }}>NBA-MCP Live</span>
              </div>
              <div style={{ display:'flex',flexDirection:'column',gap:'6px',maxHeight:'340px',overflowY:'auto' }}>
                {futureHomeGames.map(g => (
                  <div key={g.id} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'rgba(34,59,110,0.3)',borderRadius:'8px' }}>
                    <div><div style={{ fontSize:'13px',fontWeight:'500' }}>vs {g.opp}</div><div style={{ fontSize:'10px',color:'#BDBEBE' }}>{g.date}, 2026</div></div>
                    <div style={{ textAlign:'right' }}><div style={{ fontSize:'11px',color:'#06B6D4' }}>{g.time}</div><div style={{ fontSize:'9px',color:'#BDBEBE' }}>{g.tri}</div></div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'18px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'14px' }}>
                <h3 style={{ fontSize:'13px',fontWeight:'600',color:'#C4CED4',margin:0 }}>Scoring Leaders 2025-26</h3>
                <CheckCircle size={12} color="#10B981" />
                <span style={{ fontSize:'9px',color:'#10B981',marginLeft:'auto' }}>NBA-MCP Live</span>
              </div>
              <div style={{ display:'flex',flexDirection:'column',gap:'6px' }}>
                {leagueLeaders.map(p => (
                  <div key={p.rank} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',borderRadius:'8px',background:p.isSpurs?'rgba(96,87,168,0.3)':'rgba(34,59,110,0.2)',border:p.isSpurs?'1px solid rgba(96,87,168,0.5)':'1px solid transparent' }}>
                    <div style={{ display:'flex',alignItems:'center',gap:'10px' }}>
                      <span style={{ fontSize:'11px',color:'#BDBEBE',width:'28px' }}>#{p.rank}</span>
                      <div><div style={{ fontSize:'12px',fontWeight:p.isSpurs?'600':'400' }}>{p.name}{p.isSpurs&&' \u2605'}</div><div style={{ fontSize:'9px',color:'#BDBEBE' }}>{p.team} - {p.gp} GP</div></div>
                    </div>
                    <div style={{ display:'flex',gap:'14px',fontSize:'11px' }}>
                      <span style={{ color:p.isSpurs?'#6057A8':'#06B6D4',fontWeight:'600' }}>{p.ppg}</span>
                      <span style={{ color:'#BDBEBE' }}>{p.rpg}r</span>
                      <span style={{ color:'#BDBEBE' }}>{p.apg}a</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ marginTop:'20px',padding:'16px 20px',background:'rgba(245,158,11,0.08)',border:'1px solid rgba(245,158,11,0.3)',borderRadius:'12px' }}>
            <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'8px' }}>
              <AlertTriangle size={16} color="#F59E0B" />
              <span style={{ fontSize:'12px',fontWeight:'600',color:'#F59E0B' }}>Data Freshness Notice</span>
            </div>
            <p style={{ fontSize:'11px',color:'#BDBEBE',margin:0,lineHeight:'1.6' }}>
              <strong style={{ color:'#F59E0B' }}>Ticketmaster MCP</strong>: Connector contains Oct-Nov 2025 events only. All games have been played. No 2026 ticket inventory loaded. See "Historical Tickets" tab for baseline data.
              <br /><strong style={{ color:'#EF4444' }}>BigQuery</strong>: Connection failed - fan segments and audience intelligence unavailable.
              <br /><strong style={{ color:'#10B981' }}>NBA-MCP</strong>: Fully current. 2025-26 season schedule, stats, and standings verified live.
            </p>
          </div>
        </>)}

        {activeTab === 'schedule' && (
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'20px' }}>
            <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'20px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'16px' }}><h3 style={{ fontSize:'14px',fontWeight:'600',margin:0 }}>Home ({futureHomeGames.length})</h3><CheckCircle size={14} color="#10B981" /></div>
              <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
                {futureHomeGames.map(g => (
                  <div key={g.id} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px',background:'rgba(34,59,110,0.3)',borderRadius:'8px' }}>
                    <div><div style={{ fontSize:'14px',fontWeight:'500' }}>vs {g.opp}</div><div style={{ fontSize:'11px',color:'#BDBEBE' }}>{g.date}, 2026</div></div>
                    <div style={{ textAlign:'right' }}><div style={{ fontSize:'12px',color:'#06B6D4',fontWeight:'500' }}>{g.time}</div><div style={{ fontSize:'9px',color:'#10B981' }}>Frost Bank Center</div></div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'20px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'16px' }}><h3 style={{ fontSize:'14px',fontWeight:'600',margin:0 }}>Away ({nbaAwayGames.length})</h3><CheckCircle size={14} color="#10B981" /></div>
              <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
                {nbaAwayGames.map((g,i) => (
                  <div key={i} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px',background:'rgba(34,59,110,0.2)',borderRadius:'8px' }}>
                    <div><div style={{ fontSize:'14px',fontWeight:'500' }}>@ {g.opp}</div><div style={{ fontSize:'11px',color:'#BDBEBE' }}>{g.date}, 2026</div></div>
                    <div style={{ fontSize:'12px',color:'#BDBEBE' }}>{g.time}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'stats' && (
          <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'24px' }}>
            <div style={{ display:'flex',alignItems:'center',gap:'10px',marginBottom:'20px' }}><h3 style={{ fontSize:'16px',fontWeight:'600',margin:0 }}>2025-26 NBA Scoring Leaders</h3><CheckCircle size={16} color="#10B981" /><span style={{ fontSize:'11px',color:'#10B981' }}>NBA-MCP Verified</span></div>
            <div style={{ marginBottom:'24px',padding:'22px',background:'linear-gradient(135deg,rgba(96,87,168,0.25),rgba(34,59,110,0.3))',borderRadius:'14px',border:'1px solid rgba(96,87,168,0.4)' }}>
              <div style={{ fontSize:'10px',color:'#BDBEBE',marginBottom:'8px',textTransform:'uppercase',letterSpacing:'0.05em' }}>Spurs Leading Scorer</div>
              <div style={{ display:'flex',alignItems:'center',gap:'20px' }}>
                <div style={{ fontSize:'36px',fontWeight:'700',color:'#6057A8' }}>#18</div>
                <div style={{ flex:1 }}><div style={{ fontSize:'22px',fontWeight:'700' }}>De'Aaron Fox</div><div style={{ fontSize:'12px',color:'#BDBEBE' }}>San Antonio Spurs - 62 GP - 36.1 MPG</div></div>
                <div style={{ display:'flex',gap:'20px',textAlign:'center' }}>
                  <div><div style={{ fontSize:'28px',fontWeight:'700',color:'#10B981' }}>23.5</div><div style={{ fontSize:'10px',color:'#BDBEBE' }}>PPG</div></div>
                  <div><div style={{ fontSize:'28px',fontWeight:'700',color:'#06B6D4' }}>4.8</div><div style={{ fontSize:'10px',color:'#BDBEBE' }}>RPG</div></div>
                  <div><div style={{ fontSize:'28px',fontWeight:'700',color:'#F59E0B' }}>6.3</div><div style={{ fontSize:'10px',color:'#BDBEBE' }}>APG</div></div>
                </div>
              </div>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px' }}>
              {leagueLeaders.filter(l => !l.isSpurs).map(p => (
                <div key={p.rank} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px',background:'rgba(34,59,110,0.2)',borderRadius:'10px' }}>
                  <div style={{ display:'flex',alignItems:'center',gap:'12px' }}>
                    <span style={{ fontSize:'16px',fontWeight:'700',color:'#06B6D4',width:'32px' }}>#{p.rank}</span>
                    <div><div style={{ fontSize:'13px',fontWeight:'500' }}>{p.name}</div><div style={{ fontSize:'10px',color:'#BDBEBE' }}>{p.team} - {p.gp} GP</div></div>
                  </div>
                  <div style={{ display:'flex',gap:'12px',fontSize:'12px' }}>
                    <span style={{ color:'#10B981',fontWeight:'600' }}>{p.ppg}</span>
                    <span style={{ color:'#BDBEBE' }}>{p.rpg}r</span>
                    <span style={{ color:'#BDBEBE' }}>{p.apg}a</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'historical tickets' && (<div>
          <div style={{ padding:'16px 20px',background:'rgba(245,158,11,0.1)',border:'1px solid rgba(245,158,11,0.3)',borderRadius:'12px',marginBottom:'20px' }}>
            <div style={{ display:'flex',alignItems:'center',gap:'8px',marginBottom:'6px' }}><AlertTriangle size={16} color="#F59E0B" /><span style={{ fontSize:'13px',fontWeight:'600',color:'#F59E0B' }}>Historical Data - All Games Played</span></div>
            <p style={{ fontSize:'11px',color:'#BDBEBE',margin:0,lineHeight:'1.5' }}>
              The Spurs-Ticketmaster MCP connector contains <strong style={{ color:'#F59E0B' }}>October-November 2025</strong> events only. These games have been played. No 2026 ticket inventory is available. This data serves as a baseline benchmark for inventory and pricing patterns.
            </p>
          </div>
          <div style={{ background:'linear-gradient(145deg,rgba(13,33,69,0.8),rgba(4,22,36,0.9))',border:'1px solid rgba(96,87,168,0.2)',borderRadius:'14px',padding:'20px' }}>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px' }}>
              <h3 style={{ fontSize:'14px',fontWeight:'600',margin:0 }}>Ticketmaster Snapshot (Oct-Nov 2025)</h3>
              <div style={{ fontSize:'12px',color:'#06B6D4' }}>Total: <strong>{totalHistoricalOffers.toLocaleString()}</strong> offers / Avg: <strong>{avgOffersPerGame}</strong>/game</div>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px' }}>
              {historicalTicketData.map((e,i) => (
                <div key={i} style={{ padding:'14px',background:'rgba(34,59,110,0.3)',borderRadius:'10px',border:'1px dashed rgba(245,158,11,0.2)' }}>
                  <div style={{ display:'flex',justifyContent:'space-between',marginBottom:'8px' }}>
                    <div><div style={{ fontSize:'13px',fontWeight:'500' }}>vs {e.opp}</div><div style={{ fontSize:'10px',color:'#F59E0B' }}>{e.date}</div></div>
                    <span style={{ fontSize:'9px',padding:'3px 8px',borderRadius:'4px',background:e.type==='Preseason'?'rgba(245,158,11,0.2)':'rgba(96,87,168,0.2)',color:e.type==='Preseason'?'#F59E0B':'#C4CED4' }}>{e.type}</span>
                  </div>
                  <div style={{ display:'flex',justifyContent:'space-between' }}>
                    <div><div style={{ fontSize:'9px',color:'#BDBEBE' }}>Offers</div><div style={{ fontSize:'16px',fontWeight:'600',color:'#06B6D4' }}>{e.offers.toLocaleString()}</div></div>
                    <div style={{ textAlign:'right' }}><div style={{ fontSize:'9px',color:'#BDBEBE' }}>Price Range</div><div style={{ fontSize:'12px',fontWeight:'500' }}>{e.priceRange}</div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>)}
      </div>

      {chatOpen && (
        <div style={{ position:'fixed',bottom:'20px',right:'20px',width:'420px',height:'500px',background:'linear-gradient(145deg,rgba(13,33,69,0.98),rgba(4,22,36,0.99))',border:'1px solid rgba(96,87,168,0.4)',borderRadius:'18px',display:'flex',flexDirection:'column',boxShadow:'0 20px 50px rgba(0,0,0,0.5)',zIndex:1000 }}>
          <div style={{ padding:'12px 16px',borderBottom:'1px solid rgba(96,87,168,0.2)',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
            <div style={{ display:'flex',alignItems:'center',gap:'8px' }}>
              <div style={{ width:'30px',height:'30px',background:'linear-gradient(135deg,#6057A8,#223B6E)',borderRadius:'8px',display:'flex',alignItems:'center',justifyContent:'center' }}><Zap size={14} /></div>
              <div><div style={{ fontSize:'12px',fontWeight:'600' }}>MCP Intelligence Assistant</div><div style={{ fontSize:'9px',color:'#10B981' }}>Data-aware - fresh vs stale</div></div>
            </div>
            <button onClick={() => setChatOpen(false)} style={{ background:'none',border:'none',color:'#BDBEBE',cursor:'pointer' }}><X size={16} /></button>
          </div>
          <div style={{ flex:1,overflowY:'auto',padding:'12px' }}>
            {messages.map((m,i) => (
              <div key={i} style={{ marginBottom:'12px',display:'flex',justifyContent:m.role==='user'?'flex-end':'flex-start' }}>
                <div style={{ maxWidth:'85%',padding:'10px 12px',borderRadius:m.role==='user'?'12px 12px 4px 12px':'12px 12px 12px 4px',background:m.role==='user'?'linear-gradient(135deg,#6057A8,#223B6E)':'rgba(34,59,110,0.4)',fontSize:'11px',lineHeight:'1.5',whiteSpace:'pre-wrap' }}>{m.content}</div>
              </div>
            ))}
            {loading && <div style={{ display:'flex',alignItems:'center',gap:'6px',color:'#BDBEBE' }}><Loader2 size={12} style={{ animation:'spin 1s linear infinite' }} /><span style={{ fontSize:'10px' }}>Querying...</span></div>}
            <div ref={chatEnd} />
          </div>
          {messages.length <= 2 && (
            <div style={{ padding:'0 12px 8px',display:'flex',flexWrap:'wrap',gap:'4px' }}>
              {sampleQuestions.slice(0,3).map((q,i) => (
                <button key={i} onClick={() => setInput(q)} style={{ padding:'4px 8px',background:'rgba(96,87,168,0.2)',border:'1px solid rgba(96,87,168,0.3)',borderRadius:'6px',color:'#C4CED4',fontSize:'9px',cursor:'pointer' }}>{q.length>35?q.slice(0,35)+'...':q}</button>
              ))}
            </div>
          )}
          <div style={{ padding:'10px 12px',borderTop:'1px solid rgba(96,87,168,0.2)' }}>
            <div style={{ display:'flex',gap:'8px' }}>
              <input type="text" value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleSend()} placeholder="Ask about schedule, stats, tickets..." style={{ flex:1,padding:'9px 12px',background:'rgba(34,59,110,0.4)',border:'1px solid rgba(96,87,168,0.3)',borderRadius:'10px',color:'#fff',fontSize:'11px',outline:'none' }} />
              <button onClick={handleSend} disabled={loading||!input.trim()} style={{ padding:'9px 12px',background:loading?'rgba(96,87,168,0.3)':'linear-gradient(135deg,#6057A8,#223B6E)',border:'none',borderRadius:'10px',color:'#fff',cursor:loading?'not-allowed':'pointer' }}><Send size={14} /></button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
